// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"925":"63ea40ff","964":"0ab704cc"}[chunkId] + ".chunk.css";
};